import { render, staticRenderFns } from "./EmptyArea.vue?vue&type=template&id=27ac0c6a&scoped=true"
import script from "./EmptyArea.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyArea.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmptyArea.vue?vue&type=style&index=0&id=27ac0c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ac0c6a",
  null
  
)

export default component.exports